import {
  Archive,
  BarChart2,
  Gift,
  Home,
  Package,
  Send,
  Share2,
  ShoppingBag,
  ShoppingCart,
  MessageCircle,
  User,
  Users
} from 'react-feather'

// eslint-disable-next-line import/no-anonymous-default-export
export default [
  !window.ENABLE_SHIPPING_ANALYTICS_PAGE
    ? {
        id: 'Home-v2',
        title: 'Home',
        icon: <Home size={12} />,
        navLink: '/brands/experience',
        action: 'true',
        resource: 'brands_v2'
      }
    : null,
  {
    id: 'Catalogue-v2',
    title: 'Catalogue',
    icon: <ShoppingCart size={12} />,
    navLink: '/brands/kit-creator',
    action: 'true',
    resource: 'brands_v2',
    children: [
      {
        id: 'CatalogueItem-v2',
        title: 'Catalogue',
        icon: <ShoppingCart size={12} />,
        navLink: '/brands/kit-creator',
        action: 'true',
        resource: 'brands_v2'
      },
      {
        id: 'EspecialPacks-v2',
        title: 'Kits 2025',
        icon: <Gift size={12} />,
        navLink: '/brands/especial-packs',
        action: 'true',
        resource: 'brands_v2'
      }
    ]
  },
  {
    id: 'Orders-v2',
    title: 'Orders',
    icon: <ShoppingBag size={12} style={{ marginTop: '-3px' }} />,
    navLink: '/brands/orders',
    action: 'list',
    resource: 'orders',
    permissions: 'readOrders'
  },
  window.ENABLE_SHIPPING_ANALYTICS_PAGE
    ? {
        id: 'Analytics',
        title: 'Analytics',
        icon: <BarChart2 size={12} />,
        navLink: '/analytics',
        action: 'list',
        resource: 'shipments',
        permissions: 'readAnalytics'
      }
    : null,
  window.ENABLE_CONTACTS_PAGE
    ? {
        id: 'Contatos',
        title: 'Contatos',
        icon: <Users size={12} />,
        navLink: '/contacts',
        action: 'true',
        resource: 'brands_v2',
        permissions: 'readContacts'
      }
    : null,
  {
    id: 'Stock-v2',
    title: 'Stock',
    icon: <Archive size={12} />,
    navLink: '/brands/inventory',
    action: 'list',
    resource: 'inventory',
    children: [
      {
        id: 'Stock-v2',
        title: 'Estoque',
        icon: <Archive size={12} />,
        navLink: '/brands/inventory',
        action: 'list',
        resource: 'inventory'
      },
      {
        id: 'Packages-v2',
        title: 'Packages',
        icon: <Package size={12} />,
        navLink: '/brands/packages',
        action: 'list',
        resource: 'inventory_packages'
      }
    ]
  },

  {
    id: 'Shipping-v2',
    title: 'Envios',
    icon: <Send size={12} />,
    navLink: '/brands/individual-shippings',
    action: 'list',
    resource: 'shipments',
    permissions: 'readShippings',
    children: window.SINGLE_SHIPPINGS_ENABLED
      ? [
          {
            id: 'ShippingBatches-v2',
            title: 'Ordens de envio',
            icon: <Send size={12} />,
            navLink: '/brands/shipping-batches',
            action: 'list',
            resource: 'shipments_shipment-batch'
          },
          {
            id: 'Shippings-v2',
            title: 'Individual shippings',
            icon: <User size={12} />,
            navLink: '/brands/individual-shippings',
            action: 'list',
            resource: 'shipments_single-shipments'
          },
          {
            id: 'SingleShippings-v2',
            title: 'Grandes envios',
            icon: <Package size={12} />,
            navLink: '/single-shippings',
            action: 'list',
            resource: 'shipments_single-shipments',
            badge: 'primary',
            badgeText: '.'
          }
        ]
      : [
          {
            id: 'ShippingBatches-v2',
            title: 'Ordens de envio',
            icon: <Send size={12} />,
            navLink: '/brands/shipping-batches',
            action: 'list',
            resource: 'shipments_shipment-batch'
          },
          {
            id: 'Shippings-v2',
            title: 'Individual shippings',
            icon: <User size={12} />,
            navLink: '/brands/individual-shippings',
            action: 'list',
            resource: 'shipments_single-shipments'
          }
        ]
  },
  window.ENABLE_USER_FEEDBACK_PAGE
    ? {
        id: 'Feedbacks',
        title: 'Feedbacks',
        icon: <MessageCircle size={12} />,
        navLink: '/feedbacks',
        action: 'true',
        resource: 'brands_v2',
        permissions: 'readFeedbacks'
      }
    : null,
  window.FEATURE_REDEEM_PAGES
    ? {
        id: 'RedeemPages',
        title: 'Resgates',
        icon: <Gift size={12} />,
        navLink: '/brands/redeem-pages',
        action: 'true',
        resource: 'brands_v2',
        permissions: 'readRedeems'
      }
    : null,

  {
    id: 'Integration',
    title: 'Integrações',
    icon: <Share2 size={12} />,
    navLink: '/brands/integration',
    action: 'true',
    resource: 'brands_v2',
    permissions: 'readIntegrations'
  }
].filter((item) => item !== null)
